import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { RouterParams } from '../../../app/shared/interfaces';
import Breadcrumbs, { BreadcrumbsItem } from '../../../template/MainTheme/components/Breadcrumbs';
import { AuthContext } from '../../../contexts/AuthContext';
import useCurrencyService from '../../../app/services/hooks/useCurrencyService';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import DefaultCard from '../../../components/default/DefaultCard';
import LazyLoading from '../../../components/LazyLoading';
import { toast } from 'react-toastify';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';
import { AppContext } from '../../../contexts/AppContext';
import useNavigationPage from '../../../hooks/useNavigationPage';
import { Currency, defaultCurrency } from '../../../app/models/Currency';
import CurrencyForm from '../components/forms/CurrencyForm';
import CurrencyCalendar from '../components/Calendar/CurrencyCalendar';
import { Tab, Tabs } from 'react-bootstrap';

const CurrencyEdit = () => {
    const { navigationPage } = useNavigationPage();
    const { showLoading, hideLoading } = useContext(AppContext);
    const { id } = useParams<RouterParams>();

    const breadcrumbs: BreadcrumbsItem[] = [
        {
            name: 'Monedas',
            url: '/currencies',
            isActive: false
        },
        {
            name: 'Editar moneda #' + id,
            url: '/currencies/' + id + '/edit',
            isActive: true
        }
    ];

    const { auth } = useContext(AuthContext);

    const {
        editCurrency,
        fetchingEditCurrency,
        fetchingUpdateCurrency,
        updateCurrency,
    } = useCurrencyService();

    const [currency, setCurrency] = useState<Currency>(defaultCurrency);
    const [errorFields, setErrorFields] = useState<any>();

    useEffect(() => {
        reloadModule();
    }, [id]);

    const edit = (id: number) => {
        editCurrency(id, {
            onSuccess: (response: ServiceResponse) => {
                setCurrency(response.data.currency);
            },
            onError: (response: ServiceResponse) => {
                toast.error(response.message);
                if (response.data.to_dashboard) {
                    navigationPage('/currencies');
                }
            }
        });
    };

    const reloadModule = () => {
        edit(parseInt(id));
    };

    const update = () => {
        if (currency != null) {
            if (showLoading) showLoading('loading', 'Actualizando moneda...');
            updateCurrency(parseInt(id), currency, {
                onSuccess: (response: ServiceResponse) => {
                    if (hideLoading) hideLoading();
                    toast.success('Moneda actualizada correctamente');
                    navigationPage('/currencies');
                },
                onError: (response: ServiceResponse) => {
                    if (hideLoading) hideLoading();
                    toast.error(response.message);
                    setErrorFields(response.data.errors);
                }
            });
        }
    };

    return (
        <>
            <Breadcrumbs pageSection={`Editar Moneda #${id}`} breadcrumbs={breadcrumbs} />

            <Tabs defaultActiveKey="data" className="mb-3">
                <Tab eventKey="data" title="Datos">
                    <div className="row">
                        <div className="col-md-6">
                            <DefaultCard>
                                {/* <div className="h3 mt-0 mb-2 card-title">Datos Generales</div> */}
                                {!fetchingEditCurrency ? (
                                    <>
                                        <CurrencyForm
                                            currencyDataForm={currency}
                                            setCurrencyDataForm={setCurrency}
                                            errorFields={errorFields}
                                        />
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="row justify-content-end mb-3">
                                                    <div className="col-auto">
                                                        <ButtonSaveForm
                                                            callbackSave={update}
                                                            locked={fetchingUpdateCurrency}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                ) : (
                                    <LazyLoading />
                                )}
                            </DefaultCard>
                        </div>
                    </div>
                </Tab>
                <Tab eventKey="calendar" title="Calendario">
                    <div className="row">
                        <div className="col-md-12">
                                <CurrencyCalendar currencyId={parseInt(id)} />
                        </div>
                    </div>
                </Tab>
            </Tabs>
        </>
    );
};

export default CurrencyEdit; 